import { FC, useEffect, useState } from 'react'
import { push } from 'connected-react-router'
import { isFulfilled } from '@reduxjs/toolkit'

import {
  TGetProjectIdLinkedToTwitterRequestOauthToken,
  TPostSetTwitterUserAccessTokenPayload,
  TProjectSocialTwitter
} from '../../store/project/types'
import {
  getProjectIdLinkedToTwitterRequestOauthTokenThunk,
  postSetTwitterUserAccessTokenThunk
} from '../../store/project/thunks'
import { useDispatch, useSelector } from '../../store/index'
import { addProjectSocialAction } from '../../store/agency/slice'
import './ConnectSocialAccounts.scss'
import { AUTH_ROUTE } from '../App/routes'
import { generatePath } from 'react-router'
import { TAddProjectSocialPayload } from '../../store/agency/types'
import Preloader from '../../components/Preloader'
import { addProjectSocialToCurrentProject, chooseProjectAction } from '../../store/project/slice'
import { setUserRoleAction } from '../../store/auth/slice'

interface ICallBack {}

const TwitterCallBack: FC<ICallBack> = (props) => {
  const dispatch = useDispatch()
  const { projects, oauthToken, oauthVerifier, denied } = useSelector(
    ({ agency: { projects }, router: { location } }) => {
      const oauthToken: string = (location as any).query.oauth_token
      const oauthVerifier: string = (location as any).query.oauth_verifier
      const denied: string = (location as any).query.denied
      return { projects, oauthVerifier, oauthToken, denied }
    }
  )
  const [count, setCount] = useState<number>(0)

  useEffect(()=>{
    if (oauthToken && oauthVerifier) {
      setCount(count + 1)
    }
  },[oauthToken, oauthVerifier])

  useEffect(() => {
    if (oauthToken && oauthVerifier && count == 1) {
      connectTwitter()
    }
  }, [oauthToken, oauthVerifier, count])

  useEffect(() => {
    if (denied) {
      cancelConnectProccess()
    }
  }, [denied])

  const cancelConnectProccess = async () => {
    try {
      const payload: TGetProjectIdLinkedToTwitterRequestOauthToken = {
        oauth_token: denied
      }

      const responseGetProjectIdLinkedToTwitterRequestOauthTokenThunk = await dispatch(
        getProjectIdLinkedToTwitterRequestOauthTokenThunk(payload)
      )
      if (isFulfilled(responseGetProjectIdLinkedToTwitterRequestOauthTokenThunk)) {
        const {
          payload: { data: projectSocial }
        } = responseGetProjectIdLinkedToTwitterRequestOauthTokenThunk

        const projectId = projectSocial.projectId

        const project = projects.find(({ id }) => projectId === id)
        if (project) {
          dispatch(setUserRoleAction(project.role))
          dispatch(chooseProjectAction(project))
        }
        dispatch(
          push(
            generatePath(AUTH_ROUTE.SOCIAL_ACCOUNTS, {
              projectId: projectId as number
            })
          )
        )
      }
    } catch (e) {
      console.error(e)
    }
  }

  const connectTwitter = async () => {
    try {
      const payloadTwitter: TPostSetTwitterUserAccessTokenPayload = {
        oauth_token: oauthToken,
        oauth_verifier: oauthVerifier
      }

      const responsePostSetTwitterUserAccessTokenThunk = await dispatch(
        postSetTwitterUserAccessTokenThunk(payloadTwitter)
      )

      if (isFulfilled(responsePostSetTwitterUserAccessTokenThunk)) {
        const {
          payload: { data: projectSocial }
        } = responsePostSetTwitterUserAccessTokenThunk

        const projectSocialPayload: TProjectSocialTwitter = projectSocial
        const projectId = projectSocialPayload.project_id

        const payload: TAddProjectSocialPayload = {
          projectId: projectId,
          projectSocial: projectSocialPayload
        }
        const project = projects.find(({ id }) => projectId === id)
        if (project) {
          dispatch(chooseProjectAction(project))
          dispatch(addProjectSocialToCurrentProject(payload))
        }
        dispatch(addProjectSocialAction(payload))
        dispatch(
          push(
            generatePath(AUTH_ROUTE.SOCIAL_ACCOUNTS, {
              projectId: projectId as number
            })
          )
        )
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='page-container'>
      <Preloader />
    </div>
  )
}

export default TwitterCallBack
